import { h, Host } from '@stencil/core';
import { send, productSelectorVirtualPageEvent, isAnalyticsEnabled, getQdsIconLibrary, ConfiguratorHandler, EQdsButtonSize, EQdsButtonImportance } from '@pes-ui/utils';
export class CtaProductSelector {
  constructor() {
    var _a;
    this.unifiedCheckoutFlag = (_a = ConfiguratorHandler.getSingleConfig('FeatureFlags')) === null || _a === void 0 ? void 0 : _a.unifiedCheckout;
    this.isUnifiedCheckoutEnabled = ConfiguratorHandler.isFeatureFlagEnabled(this.unifiedCheckoutFlag || {});
    this.openProductSelector = (selector) => (_) => {
      var _a;
      const modal = document.createElement('pdp-sc-selector-modal');
      const frame = document.createElement('div');
      frame.id = 'widgetFrame';
      modal.headerLabel = ((_a = this.selectorConfig) === null || _a === void 0 ? void 0 : _a.scLabel) || 'Select your product';
      modal.appendChild(frame);
      modal.open = true;
      modal.addEventListener('didClose', () => {
        document.body.removeChild(modal);
      });
      document.body.appendChild(modal);
      if (this.isUnifiedCheckoutEnabled) {
        this.selectorConfig.options.buttons = {
          saveConfiguration: {
            title: this.addToMyCartLabel,
            isVisible: true,
          },
          addToListConfiguration: {
            title: this.addToMyListLabel,
            isVisible: true,
          },
        };
      }
      selector.open(this.selectorConfig);
      if (isAnalyticsEnabled()) {
        send(productSelectorVirtualPageEvent);
      }
    };
    this.selectorConfig = undefined;
    this.isCtaArea = false;
    this.buttonProps = undefined;
    this.enableProductSelectorButton = undefined;
    this.showProductSelectorStatus = {
      isExternalState: false,
      loaded: false,
      state: false,
    };
    this.addToMyCartLabel = undefined;
    this.addToMyListLabel = undefined;
    this.showProductSelector = false;
    this.showCtaSelectorButton = undefined;
    this.showSelectorLink = undefined;
  }
  componentWillRender() {
    var _a;
    if (!this.selectorConfig
      || (((_a = this.showProductSelectorStatus) === null || _a === void 0 ? void 0 : _a.isExternalState)
        && this.showProductSelector === this.showProductSelectorStatus.state)) {
      return;
    }
    const { isExternalState, loaded, state } = this.showProductSelectorStatus;
    if (isExternalState && loaded) {
      this.showProductSelector = state;
    }
    if (!this.showProductSelector) {
      return;
    }
    const { enableProductSelectorButton } = this.selectorConfig;
    this.showCtaSelectorButton = enableProductSelectorButton && this.isCtaArea;
    this.showSelectorLink = !(enableProductSelectorButton || this.isCtaArea);
  }
  render() {
    if (!this.showProductSelector || (!this.showCtaSelectorButton && !this.showSelectorLink))
      return;
    return (h(Host, { class: "subsection__item" }, h("pes-product-selector", { config: this.selectorConfig, renderFunction: (selector) => {
        var _a, _b, _c, _d;
        if (this.showCtaSelectorButton) {
          return (h("pes-cta-button", { class: "cta-area__button", importance: (_a = this.buttonProps) === null || _a === void 0 ? void 0 : _a.importance, size: EQdsButtonSize.LARGE, text: (_b = this.buttonProps) === null || _b === void 0 ? void 0 : _b.label, icon: (_c = this.buttonProps) === null || _c === void 0 ? void 0 : _c.icon, onClick: this.openProductSelector(selector), "data-autotests-id": 'props.dataset?.autotestId' }));
        }
        if (this.showSelectorLink) {
          return (h("qds-button", { importance: EQdsButtonImportance.SUBDUED, "icon-name": "squares-checked", text: (_d = this.selectorConfig) === null || _d === void 0 ? void 0 : _d.buttonlabel, onClick: this.openProductSelector(selector), "icon-library": getQdsIconLibrary("squares-checked") }));
        }
      } })));
  }
  static get is() { return "pes-cta-product-selector"; }
  static get encapsulation() { return "shadow"; }
  static get properties() {
    return {
      "selectorConfig": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TScHpcProductSelectorConfig",
          "resolved": "Omit<TScProductSelectorConfig, \"type\"> & Omit<THpcProductSelectorConfig, \"type\"> & { type: \"hpc\" | \"cr\" | \"sc\"; }",
          "references": {
            "TScHpcProductSelectorConfig": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "The data for initializing product selector."
        }
      },
      "isCtaArea": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-cta-area",
        "reflect": false,
        "defaultValue": "false"
      },
      "buttonProps": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TButtonProps",
          "resolved": "{ label: string; importance?: EQdsButtonImportance; icon?: string; onClick(event: MouseEvent): void; link?: string; dataset?: { [key: string]: string; }; showTags?: boolean; tagText?: string; }",
          "references": {
            "TButtonProps": {
              "location": "import",
              "path": "../cta-area-se-container/types"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "enableProductSelectorButton": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "enable-product-selector-button",
        "reflect": false
      },
      "showProductSelectorStatus": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TProductSelectorStatus",
          "resolved": "{ loaded: boolean; isExternalState: boolean; state: boolean; }",
          "references": {
            "TProductSelectorStatus": {
              "location": "import",
              "path": "../../../globals/types"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "defaultValue": "{\n    isExternalState: false,\n    loaded: false,\n    state: false,\n  }"
      },
      "addToMyCartLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "add-to-my-cart-label",
        "reflect": false
      },
      "addToMyListLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "add-to-my-list-label",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "showProductSelector": {},
      "showCtaSelectorButton": {},
      "showSelectorLink": {}
    };
  }
}
